<template>
  <BModal
    v-model="show"
    title="Neues Spiel"
    hide-footer
  >
    <BForm
      @submit.prevent="onCreateGame"
    >
      <BFormGroup
        label-cols-sm="4"
        label-cols-lg="3"
        label="Name"
        label-for="modal-new-game__name"
        :state="stateNewGameName"
      >
        <BFormInput
          id="modal-new-game__name"
          v-model="name"
          :state="stateNewGameName"
          trim
          :disabled="creating"
        />
      </BFormGroup>
      <BFormGroup
        v-if="!hidePlayerCount"
        label-cols-sm="4"
        label-cols-lg="3"
        :label="`Spieler: ${requiredPlayers}`"
        label-for="modal-new-game__required-players"
      >
        <BFormInput
          id="modal-new-game__required-players"
          v-model="requiredPlayers"
          :disabled="creating"
          type="range"
          min="3"
          max="6"
        />
      </BFormGroup>
      <BButton
        type="submit"
        variant="primary"
        :disabled="!stateNewGameName || creating"
      >
        Erstellen
      </BButton>
    </BForm>
  </BModal>
</template>

<script>
export default {
  name: 'ModalNewGame',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    hidePlayerCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      creating: false,
      name: null,
      requiredPlayers: 4,
    };
  },
  computed: {
    stateNewGameName() {
      if (this.name == null) {
        return null;
      }
      return this.name.length >= 3;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async onCreateGame() {
      this.creating = true;
      await this.$emit('create', {
        name: this.name,
        requiredPlayers: Number(this.requiredPlayers),
      });
      this.creating = false;
    },
  },
};
</script>

<style scoped>

</style>
